;(function($) {

    function elementInViewport(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;

        while(el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }

    var check = [];

    $(window).on('DOMContentLoaded load resize scroll', function() {
        check.forEach(function(c) {
            c.elements.forEach(function (el) {
                c.callback(elementInViewport(el), el);
            })
        })
    });

    $.fn.inViewport = function(cb) {
        var elements = this.get();

        if(elements.length && cb){
            check.push({
                elements: elements,
                callback: cb
            })
        }
    }
})(jQuery);
